<script lang="ts">
  import { onMount } from "svelte";
  import CustomerDropdown from "../../components/Business/CustomerDropdown.svelte";
  import DossierStatusDropdown from "../../components/Business/DossierStatusDropdown.svelte";
  import DossierTypeDropdown from "../../components/Business/DossierTypeDropdown.svelte";
  import DossierYearsRangeDropdown from "../../components/Business/DossierYearsRangeDropdown.svelte";
  import Button from "../../components/Button.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  // import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import Icon from "../../components/Icon.svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import { Table } from "../../components/Table";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { dossierDtoFields } from "../../utils/TableFields/dossier-dto.fields";
  import {
    loading,
    records,
    pagination,
    initList,
    onCreate,
    onEdit,
    onDelete,
    onPageChange,
    filter,
    search,
  } from "./dossier.store";

  onMount(initList);
</script>

<MainLayout>
  <SearchHeader
    entitySingular="pratica"
    entityPlural="pratiche"
    searchPlaceholder="cerca per titolo o protocollo"
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    searchFieldVisible={false}
    bind:searchValue={$filter.criteria.query}
    on:search={search}
  >
    <div class="level-item" slot="search">
      <div class="field">
        <p class="control" style="min-width:300px">
          <CustomerDropdown
            name=""
            placeholder="cliente"
            required={false}
            clearVisible={true}
            on:select={search}
            on:clear={search}
            bind:value={$filter.criteria.customerId}
          />
        </p>
      </div>
    </div>

    <div class="columns">
      <div class="column is-1">
        <FormField>
          <!--
          <NumberInput
            name="Anno"
            placeholder="anno"
            required={false}
            bind:value={$filter.criteria.year}
          />
          -->

          <DossierYearsRangeDropdown
            name="Anno"
            required={false}
            bind:value={$filter.criteria.year}
          />
        </FormField>
      </div>
      <div class="column">
        <FormField>
          <DossierTypeDropdown
            name="Causale Pratica"
            required={false}
            clearVisible={true}
            bind:value={$filter.criteria.dossierTypeId}
          />
        </FormField>
      </div>

      <div class="column is-2">
        <FormField>
          <DossierStatusDropdown
            name="Stato"
            required={false}
            clearVisible={true}
            bind:value={$filter.criteria.dossierStatusId}
          />
        </FormField>
      </div>

      <div class="column is-2">
        <FormField>
          <Input
            name="Protocollo"
            required={false}
            bind:value={$filter.criteria.protocol}
          />
        </FormField>
      </div>

      <div class="column is-2">
        <div class="general-search-button-container">
          <Button on:click={search}>
            <Icon name="search" />
            <span>Cerca</span>
          </Button>
        </div>
      </div>
    </div>
  </SearchHeader>

  <Table
    loading={$loading}
    fields={dossierDtoFields}
    records={$records}
    pagination={$pagination}
    createEnabled={true}
    editEnabled={true}
    deleteEnabled={true}
    on:create={(_) => onCreate()}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</MainLayout>

<style>
  .general-search-button-container {
    text-align: right;
    margin-top: 32px;
  }
</style>
